export default defineAppConfig({
  ui: {
    // `ca` = skala warna merek yang didefinisikan di app/assets/css/main.css (@theme).
    colors: {
      primary: 'ca',
      neutral: 'slate',
      success: 'emerald',
      warning: 'amber',
      error: 'red'
    }
  }
})
